import {
  showImportResultModal,
  showModalCommonExport,
} from '@/components/YiZheComponents/ModalCommonExport';
import { PAGE_HEADER_HEIGHT } from '@/constant';
import { postCommonConfigGetNoticeDetail } from '@/services/yizhe-web/gonggongfenlei';
import { postCommonMessageList, postCommonMessageRead } from '@/services/yizhe-web/yonghu';
import { postCommonUserTemporaryAuthorization } from '@/services/yizhe-web/yonghuguanli';
import { getApiUrl } from '@/utils/api';
import { dispatchImportNotifyEvent, ImportNotifyPayload } from '@/utils/importExportNotify';
import { HappyProvider } from '@ant-design/happy-work-theme';
import {
  CheckCircleFilled,
  ClearOutlined,
  CloseOutlined,
  ExclamationCircleFilled,
  MessageOutlined,
  SoundOutlined,
} from '@ant-design/icons';
import { ProList } from '@ant-design/pro-components';
import {
  Badge,
  Button,
  DatePicker,
  Drawer,
  Flex,
  Image,
  message,
  Modal,
  notification,
  Progress,
  Space,
  TimeRangePickerProps,
  Tooltip,
  Typography,
} from 'antd';
import dayjs from 'dayjs';
import { Key, startTransition, useCallback, useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';
import './index.less';
const { RangePicker } = DatePicker;

/** 顶部新消息条展示字段（WebSocket） */
interface SocketBannerMessage {
  jump_type?: number;
  production_id?: number;
  scroll_title?: string;
  template_no?: string;
  message_id?: number;
  message_type?: number;
  title?: string;
  import_progress?: number;
  notify_stage?: string;
  task_id?: number;
  production_type_desc?: string;
}

const ModalMessageNotice = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);
  const actionRef = useRef<any>(null);
  const [createdAt, setCreatedAt] = useState([dayjs().subtract(6, 'months'), dayjs()]);
  const [api, contextHolder] = notification.useNotification({
    top: 72,
    placement: 'topRight',
    maxCount: 8,
    stack: true,
  });
  const [isStartUpdateDown, setIsStartUpdateDown] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const getDetailData = async () => {
    const { code, data } = await postCommonConfigGetNoticeDetail({
      notice_id: 40,
    });
    if (code === '200') {
      Modal.success({
        icon: null,
        width: 1100,
        title: '更新详情',
        autoFocusButton: null,
        content: (
          <>
            <div
              dangerouslySetInnerHTML={{ __html: data?.notice_content }}
              className="modal-notice-detail"
            />
          </>
        ),
        closable: true,
        okText: '关闭',
        okButtonProps: { type: 'default' },
        onCancel: () => {
          //   props.update();
        },
      });
    }
  };
  interface Content {
    sub_title: string;
    summary: string;
    upgrade_start_at: string; // 更新开始时间
    upgrade_execute_at: string; // 更新执行时间
    position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight'; // 弹框位置
    version_code: string;
  }

  interface NotificationData {
    notice_id?: number; // 与summary二选一，传了notice_id获取公告的summary
    message_id: number;
    title: string;
    content: Content;
    message_type: 3 | 4; // {3:大版本更新弹框,4:小版本更新弹框}
  }
  const openNotification = (data: {
    notificationData?: NotificationData; // 新增的完整通知数据
  }) => {
    console.log('更新消息通知', data);

    if (data?.message_type === 3) {
      Modal.confirm({
        title: '衣者有新版本更新啦！',
        icon: null,
        className: 'updage-notice',
        width: 548,
        content: (
          <div className="updage-notice-content">
            <div className="x-f">
              <Image src="/logo.png" width={56} height={56} style={{ minWidth: 56 }}></Image>
              <div style={{ marginLeft: 16 }}>
                <div className="title">{data.title}</div>
                <div className="sub-text">{data.content.sub_title}</div>
              </div>
            </div>
            <div
              className="close-icon"
              onClick={() => {
                Modal.destroyAll();
              }}
            >
              <CloseOutlined style={{ color: '#fff', fontSize: 14 }} />
            </div>
            <div className="card">
              <div className="card-desc">
                <div
                  dangerouslySetInnerHTML={{ __html: data?.content.summary }}
                  //   className="modal-notice-detail"
                />
              </div>
              {data.notice_id && (
                <div className="card-desc">
                  点击
                  <a
                    className="card-desc-a"
                    onClick={() => {
                      getDetailData();
                    }}
                  >
                    查看详情
                  </a>
                </div>
              )}
            </div>
          </div>
        ),
        okText: '知道了',
        onOk() {
          console.log('OK');
        },
        onCancel() {
          console.log('Cancel');
        },
        footer: (_, { OkBtn, CancelBtn }) => (
          <>
            <OkBtn />
          </>
        ),
      });
    } else {
      api.open({
        message: <div style={{ fontWeight: 500 }}>衣者有新版本更新啦！</div>,
        description: '系统即将刷新，请及时保存当前操作，以免造成数据丢失。',
        showProgress: true,
        key: 'update-notification',
        closeIcon: null,
        btn: (
          <Space>
            <Button type="primary" size="small" onClick={() => api.destroy('update-notification')}>
              我知道了
            </Button>
          </Space>
        ),
        duration: 180, // 秒
      });
    }
  };
  const [socketMessage, setSocketMessage] = useState<SocketBannerMessage>({});

  const openImportGlobalNotification = useCallback(
    (msg: ImportNotifyPayload) => {
      const c = msg.content;
      if (!c) {
        return;
      }
      const successCount = c.success_count ?? 0;
      const failCount = c.fail_count ?? 0;
      const taskId = c.task_id;
      const importType = c.import_type;
      const typeLabel = importType === 2 ? '订单' : '样板';

      const noticeKey = `import-result-${msg.message_id ?? 'noid'}-${
        taskId ?? 'notask'
      }-${Date.now()}`;

      const isAllSuccess = failCount === 0 && successCount > 0;
      let variant: 'success' | 'warning';
      let cardTitle: string;
      let cardDesc: string;

      if (isAllSuccess) {
        variant = 'success';
        cardTitle = '导入成功';
        cardDesc = `新增 ${successCount} 条${typeLabel}数据`;
      } else {
        variant = 'warning';
        cardTitle = msg.title || '导入完成';
        if (failCount > 0 || successCount > 0) {
          cardDesc = `成功导入 ${successCount} 条，失败 ${failCount} 条`;
        } else {
          cardDesc = c.fail_msg?.trim() || '导入未产生有效数据';
        }
      }

      const onViewDetail = () => {
        api.destroy(noticeKey);
        if (taskId != null) {
          showImportResultModal(taskId);
        } else {
          showModalCommonExport();
        }
      };

      api.open({
        key: noticeKey,
        icon: null,
        closable: false,
        closeIcon: null,
        duration: 4.5,
        placement: 'topRight',
        className: `import-result-global-notification import-result-global-notification--${variant}`,
        style: { width: 428 },
        message: (
          <div className={`import-result-toast-card import-result-toast-card--${variant}`}>
            <div className="import-result-toast-card__row">
              {variant === 'success' ? (
                <CheckCircleFilled className="import-result-toast-card__icon import-result-toast-card__icon--ok" />
              ) : (
                <ExclamationCircleFilled className="import-result-toast-card__icon import-result-toast-card__icon--warn" />
              )}
              <div className="import-result-toast-card__text">
                <div className="import-result-toast-card__title">{cardTitle}</div>
                <div className="import-result-toast-card__desc">{cardDesc}</div>
              </div>
              <Button className="import-result-toast-card__action" onClick={onViewDetail}>
                查看详情
              </Button>
            </div>
          </div>
        ),
      });
    },
    [api],
  );

  const socketRef = useRef();
  //   消息通知
  useEffect(() => {
    const authParams = localStorage.getItem('tokenInfo');
    socketRef.current = io(WS_URL, {
      transports: ['websocket'],
      query: {
        app_id: 2, //表示衣者
        auth_url: getApiUrl(), // 当前请求的api地址，测试环境生效
        auth_params: authParams,
        // ... 其他用户参数
      },
      // 添加重连尝试次数配置
      reconnectionAttempts: 10, // 设置最大重连尝试次数为5次
    });

    // 监听服务器发送的消息
    socketRef?.current?.on('rooms', (msg) => {
      console.log('rooms', msg);
    });
    const handleImportNotifyPayload = (msg: ImportNotifyPayload) => {
      dispatchImportNotifyEvent(msg);
      const stage = msg?.content?.notify_stage;
      if (stage === 'done' || stage === 'failed') {
        openImportGlobalNotification(msg);
      }
    };

    socketRef?.current?.on('message', (msg: any) => {
      console.log('message', msg);
      if (msg?.message_type === 7) {
        handleImportNotifyPayload(msg);
        setSocketMessage({
          ...msg?.content,
          message_id: msg?.message_id,
          message_type: msg?.message_type,
          title: msg?.title,
        });
      } else {
        setSocketMessage(msg?.content);
      }
      socketRef?.current?.emit('unread_data', 'unread_data', (data) => {
        console.log('socketRef?.current?.connected', data);
        setCount(data.unread_count);
      });
    });

    socketRef?.current?.on('import_notify', (raw: unknown) => {
      const msg = (Array.isArray(raw) ? (raw as unknown[])[1] : raw) as
        | ImportNotifyPayload
        | null
        | undefined;
      if (!msg || typeof msg !== 'object') {
        return;
      }
      handleImportNotifyPayload(msg);
      setSocketMessage({
        ...msg?.content,
        message_id: msg?.message_id,
        message_type: msg?.message_type ?? 7,
        title: msg?.title,
      });
    });

    socketRef?.current?.on('connect', (msg) => {
      socketRef?.current?.emit('unread_data', 'unread_data', (data) => {
        console.log('connect', data, msg);

        setCount(data.unread_count);
        setSocketMessage({
          ...data?.unread_message?.content,
          message_id: data?.unread_message?.message_id,
          message_type: data?.unread_message?.message_type,
          title: data?.unread_message?.title,
        });
      });
    });
    // 检测更新
    socketRef?.current?.on('upgrade_notice', (msg) => {
      setIsStartUpdateDown(false);
      window.sessionStorage.setItem('updateTimeStart', msg.content.upgrade_start_at);
      window.sessionStorage.setItem('updateTimeEnd', msg.content.upgrade_execute_at);
      if (window.sessionStorage.getItem('hasAcceptedUpgrade') !== 'true') {
        openNotification(msg);
        setIsStartUpdateDown(true);
      }
      window.sessionStorage.setItem('hasAcceptedUpgrade', 'true'); // 标记已经弹出
    });
    // 更新时间结束，开始更新
    socketRef?.current?.on('upgrade_execute', (msg) => {
      //   启动自毁程序
      window.location.reload();
      window.sessionStorage.clear();
    });

    // 监听版本是否即将更新
    // setTimeout(() => {
    //   window.sessionStorage.setItem('updateTimeStart', '2024-10-30 14:01:00');
    //   window.sessionStorage.setItem('updateTimeEnd', '2024-10-30 14:05:00');
    //   openNotification({
    //     message_id: 173020558113943,
    //     title: '衣者最新3.1.0版本来了',
    //     content: {
    //       sub_title: '新版本更新日志如下：',
    //       summary: '1.测过<br/>2.新功能',
    //       upgrade_start_at: '2024-10-30 14:01:00', // 更新开始时间
    //       upgrade_execute_at: '2024-10-30 14:05:00', // 更新执行时间
    //       position: 'topLeft', // 弹框位置
    //       version_code: '1111',
    //     },
    //     message_type: 3, // {3:大版本更新弹框,4:小版本更新弹框}
    //   });
    //   setIsStartUpdateDown(true);
    // }, 1000);
    // 清理操作
    return () => {
      socketRef?.current?.disconnect();
    };
  }, [openImportGlobalNotification]);
  //   列表已读操作
  const handleRead = async (ids: number[]) => {
    const { code } = await postCommonMessageRead({
      message_ids: ids,
    });
    if (code === '200') {
      message.success('操作成功');
      actionRef.current.reset();
      setSelectedRowKeys([]);
      socketRef?.current?.emit('unread_data', 'unread_data', (data) => {
        setCount(data.unread_count);
        setSocketMessage({
          ...data?.unread_message?.content,
          message_id: data?.unread_message?.message_id,
        });
      });
    }
  };
  const jumpPage = async (item) => {
    switch (item.jump_type) {
      // 生产订单
      case 1:
        window.open(
          `/production-order/order-detail?production_id=${item.production_id}&template_id=${item.template_id}`,
          '_blank',
        );
        break;
      // 采购详情
      case 2:
        window.open(
          `/purchase-order/list/purchase-order-details?production_id=${item.production_id}`,
          '_blank',
        );
        break;
      case 3:
        window.open(
          `/documentary-management/documentary-detail?production_id=${item?.production_id}`,
          '_blank',
        );
        break;
      case 4:
        const { data, code } = await postCommonUserTemporaryAuthorization({});
        if (code === '200') {
          open(
            `${FS_URL}/login/transfer?authorToken=${data?.authorization_key}&appType=1&jumpType=${item?.jump_type}&jump_id=${item?.jump_params?.id}`,
          );
        }
        break;
      // 样板开发详情
      case 5: {
        const templateId = item?.jump_params?.template_id ?? item?.template_id;
        if (templateId != null) {
          window.open(`/sample-management/sample-dev-detail?template_id=${templateId}`, '_blank');
        }
        break;
      }
      case 6:
        showModalCommonExport();
        break;
      default:
        break;
    }
  };
  //   获取消息模板
  const getListItem = (item: any) => {
    return {
      title: item.title,
      key: item.id,
      dataIndex: item.id,
      id: item.id,
      actions: [
        <a
          key="delete"
          onClick={() => {
            handleRead(item.id);
            jumpPage(item.content);
          }}
        >
          查看
        </a>,
      ],
      avatar: (
        <Badge dot={item.is_read === 2}>
          <MessageOutlined style={{ fontSize: 16 }} />
        </Badge>
      ),
      content: (
        <>
          {item.message_type === 7 ? (
            <div className="card">
              <Space
                className="card-content"
                direction="vertical"
                size={2}
                style={{ width: '100%' }}
              >
                <div>
                  <div className="card-desc">{item.created_at}</div>
                </div>
                <div className="card-p">
                  导入进度：
                  <span style={{ fontWeight: 500, color: '#2150F5' }}>
                    {item.content?.import_progress != null
                      ? `${item.content.import_progress}%`
                      : '-'}
                  </span>
                </div>
                <div className="card-p">
                  成功 <span style={{ color: '#52c41a' }}>{item.content?.success_count ?? 0}</span>{' '}
                  条，失败 <span style={{ color: '#ff4d4f' }}>{item.content?.fail_count ?? 0}</span>{' '}
                  条
                </div>
                {item.content?.fail_msg ? (
                  <div className="card-p" style={{ color: '#fa8c16' }}>
                    {item.content.fail_msg}
                  </div>
                ) : null}
              </Space>
            </div>
          ) : item.content?.jump_type === 5 ? (
            <div className="card">
              <Space
                className="card-content"
                direction="vertical"
                size={2}
                style={{ width: '100%' }}
              >
                <div>
                  <div className="card-desc">{item.created_at}</div>
                </div>
                <div className="card-p">
                  开发节点：
                  <span style={{ fontWeight: 500, color: '#333' }}>
                    {item.content.step_name || '-'}
                  </span>
                </div>
                <div className="card-p">
                  <Typography.Paragraph
                    className="card-p-s"
                    style={{ marginBottom: 0, color: '#666' }}
                    ellipsis={{ rows: 3, tooltip: item.content.scroll_title }}
                  >
                    {item.content.scroll_title || '-'}
                  </Typography.Paragraph>
                </div>
              </Space>
            </div>
          ) : item.message_type === 5 ? (
            <div className="card">
              <Space
                className="card-content"
                direction="vertical"
                size={2}
                style={{ width: '100%' }}
              >
                <div>
                  {item.content.detail?.map((item2: any, index) => {
                    return (
                      <p key={index} className={`${index === 0 ? 'card-desc' : ''} card-p`}>
                        {item2}
                      </p>
                    );
                  })}
                </div>
              </Space>
            </div>
          ) : (
            <div className="card">
              <Space
                className="card-content"
                direction="vertical"
                size={2}
                style={{ width: '100%' }}
              >
                <div>
                  <div className="card-desc">{item.created_at}</div>
                </div>

                <div className="card-p">
                  款号：
                  <span style={{ fontWeight: 500, color: '#333' }}>
                    {item.content.template_no}（{item.content.production_type_desc}）
                  </span>
                </div>
                <div className="card-p">
                  工厂：
                  <Tooltip
                    style={{ marginLeft: 6 }}
                    placement="top"
                    title={
                      <span>
                        {item.content.factory_name}
                        {item.content.follower_user_name && (
                          <span className="card-p-s">
                            （{item.content.follower_user_name || '-'}）
                          </span>
                        )}
                      </span>
                    }
                  >
                    <Typography.Text style={{ maxWidth: 290, paddingRight: 6 }} ellipsis={true}>
                      <span className="card-p-s" style={{ width: 260 }}>
                        {item.content.factory_name}
                        <span>（{item.content.follower_user_name || '-'}）</span>
                      </span>
                    </Typography.Text>
                  </Tooltip>
                </div>

                <Flex className="card-p">
                  <Tooltip title={`件数：${item.content.plan_total_num}`}>
                    <Typography.Text style={{ width: '33%' }} ellipsis={true}>
                      件数：<span className="red-text">{item.content.plan_total_num}</span>
                    </Typography.Text>
                  </Tooltip>
                  <Tooltip title={`采购人：${item.content.buyer_user || '-'}`}>
                    <Typography.Text style={{ width: '33%' }} ellipsis={true}>
                      采购人：<span className="card-p-s">{item.content.buyer_user || '-'}</span>
                    </Typography.Text>
                  </Tooltip>
                  <Tooltip title={`下单人：${item.content.create_admin || '-'}`}>
                    <Typography.Text style={{ width: '33%' }} ellipsis={true}>
                      下单人：
                      <span className="card-p-s">{item.content.create_admin || '-'}</span>
                    </Typography.Text>
                  </Tooltip>
                </Flex>
              </Space>
            </div>
          )}
        </>
      ),
    };
  };

  const onClose = () => {
    setIsModalOpen(false);
    setSelectedRowKeys([]);
  };
  //  切换时间
  const onRangeChange = (dates: null | (dayjs.Dayjs | null)[], dateStrings: string[]) => {
    if (dates) {
      console.log('From: ', dates[0], ', to: ', dates[1]);
      console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    } else {
      console.log('Clear');
    }
    setCreatedAt(dates);
    actionRef?.current?.reload();
  };

  const disabledDate = (current: dayjs.Dayjs, { from }) => {
    // 禁用过去日期
    return Math.abs(current.diff(from, 'month')) >= 6;
  };

  const rangePresets: TimeRangePickerProps['presets'] = [
    { label: '近 7 天', value: [dayjs().add(-7, 'd'), dayjs()] },
    { label: '近 14 天', value: [dayjs().add(-14, 'd'), dayjs()] },
    { label: '近 30 天', value: [dayjs().add(-30, 'd'), dayjs()] },
    { label: '近 90 天', value: [dayjs().add(-90, 'd'), dayjs()] },
  ];

  //   新消息已读操作
  const handleNewsRead = async () => {
    const { code } = await postCommonMessageRead({
      message_ids: [socketMessage?.message_id],
    });
    if (code === '200') {
      socketRef?.current?.emit('unread_data', 'unread_data', (data) => {
        setCount(data.unread_count);
        setSocketMessage({});
      });
      setTimeout(() => {
        jumpPage(socketMessage);
      }, 300);
    }
  };
  const [msgAlertInfo, setMsgAlertInfo] = useState({
    width: 800,
    left: 0,
  });
  //   获取新消息弹窗的位置
  useEffect(() => {
    const mainWidth =
      document?.querySelector('.ant-layout-content.ant-pro-layout-content')?.clientWidth || 0;
    const rootWidth = document?.querySelector('#root')?.clientWidth || 0;
    const margin = 48;
    setMsgAlertInfo({
      width: mainWidth - margin,
      left: rootWidth - mainWidth + margin / 2,
    });
  }, []);

  // 倒计时
  const ProgressBar: React.FC = () => {
    const [updateProgress, setUpdateProgress] = useState(0);
    const targetSeconds = useRef(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null); // 用于存储定时器的引用

    const totalSeconds = useRef(60);

    // 获取 updateTimeStart
    useEffect(() => {
      const updateInterval = 1000; // 每100毫秒更新一次
      //   const totalUpdates = 10; // 每秒更新10次
      //   const increment = 100 / (totalSeconds.current * totalUpdates); // 每次更新的进度增量
      const updateTimeStart = window.sessionStorage.getItem('updateTimeStart');
      const updateTimeEnd = window.sessionStorage.getItem('updateTimeEnd');

      let secondsDifference = 0;
      // 将 updateTimeEnd 转换为 Day.js 对象
      const updateDayjs = dayjs(updateTimeEnd);

      // 获取当前时间的 Day.js 对象
      const nowDayjs = dayjs();
      if (updateTimeEnd) {
        // 检查 updateTimeEnd 是否不早于当前时间
        if (updateDayjs.isAfter(nowDayjs) || updateDayjs.isSame(nowDayjs)) {
          // 计算两个时间之间的差值（以秒为单位）
          secondsDifference = updateDayjs.diff(nowDayjs, 'second');

          console.log(secondsDifference);
        } else {
          console.log('updateTimeStart 早于当前时间');
        }
      } else {
        console.log('updateTimeStart 不存在');
      }
      totalSeconds.current = secondsDifference; //剩余未倒计时的秒数
      targetSeconds.current = dayjs(nowDayjs).diff(updateTimeStart, 'second'); // 已倒计时的秒杀
      intervalRef.current = setInterval(() => {
        if (totalSeconds.current <= 0) {
          clearInterval(intervalRef.current!);
        } else {
          totalSeconds.current -= updateInterval / 1000; // 每次减少的秒数
          targetSeconds.current += updateInterval / 1000; // 每次增加的秒数
          const startTime = dayjs(updateTimeStart);
          const endTime = dayjs(updateTimeEnd);
          const totalSecondsDifference = endTime.diff(startTime, 'second');
          // 使用 startTransition 来进行非紧急更新
          startTransition(() => {
            setUpdateProgress((targetSeconds.current / totalSecondsDifference) * 100);
          });
        }
      }, updateInterval);

      return () => {
        clearInterval(intervalRef.current!);
      };
    }, []);

    return (
      <div className="update-countdown">
        <Progress
          type="circle"
          trailColor="#D9D9D9"
          strokeColor="#2150F5"
          percent={updateProgress}
          strokeWidth={11}
          size={25}
          showInfo={false}
          style={{ marginRight: 4 }}
        />
        <div className={`red-text big`}>
          {/* {Math.ceil(totalSeconds.current)} 使用 Math.ceil 确保显示整数 */}
          {totalSeconds.current > 60 ? Math.ceil(totalSeconds.current / 60) : totalSeconds.current}
        </div>
        <span className="red-text">{totalSeconds.current > 60 ? '分钟' : '秒钟'}</span>
        <span>之后系统将更新重启</span>
      </div>
    );
  };
  const urlLen = location.pathname.split('/').length;

  return (
    <>
      <HappyProvider>
        <Button
          onClick={() => {
            handleNewsRead();
          }}
          style={{
            minWidth: 200,

            height: 36,
            top: (PAGE_HEADER_HEIGHT - 40) / 2,
          }}
          className={`${count > 0 ? 'has-news-msg' : 'read-news-msg'} new-msg-btn ${
            urlLen > 3 ? 'left-3' : ''
          } `}
        >
          {socketMessage.template_no ? (
            <div className="x-f">
              <div className="red-text">【新订单】</div>
              <div
                className="ellipsis-1"
                style={{ maxWidth: '100px', display: 'inline', marginRight: 4 }}
              >
                {socketMessage?.template_no}
              </div>
              <div>{socketMessage?.production_type_desc}</div>
            </div>
          ) : socketMessage?.message_type === 7 ? (
            <div className="x-f">
              <div className="red-text">【导入】</div>
              <div
                className="ellipsis-1"
                style={{ maxWidth: '160px', display: 'inline', marginRight: 4 }}
              >
                {socketMessage?.title || '导入任务'}
              </div>
              {socketMessage?.notify_stage === 'running' &&
              socketMessage?.import_progress != null ? (
                <span>{socketMessage.import_progress}%</span>
              ) : null}
            </div>
          ) : (
            socketMessage?.scroll_title
          )}
          <div></div>
        </Button>
      </HappyProvider>
      {isStartUpdateDown && <ProgressBar />}
      {contextHolder}

      {/* <Button
        onClick={() => {
          //   console.log(4234234234);
          //   api.open({
          //     message: 【新订单/新采购单】、款号、订单类型、返单号、,
          //     description:
          //       'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
          //     showProgress: true,
          //   });
          //   openNotification(true);
          //   setHasNew(true);
        }}
      >
        测试通知
      </Button> */}
      <Badge size="small" count={count} overflowCount={99} style={{ marginRight: 10 }}>
        <Button
          shape="round"
          key="modal-notice"
          style={{ color: '#666666' }}
          icon={<SoundOutlined style={{ color: '#666666' }} />}
          onClick={() => {
            setIsModalOpen(true);
          }}
          size="small"
        >
          消息通知
        </Button>
      </Badge>
      <Drawer
        title={
          <Space>
            <span>消息通知列表（{total}）</span>
            <div
              className="all-read"
              onClick={() => {
                handleRead([]);
              }}
            >
              <ClearOutlined />
            </div>
          </Space>
        }
        placement="right"
        onClose={onClose}
        open={isModalOpen}
        destroyOnClose
        className="message-drawer"
        styles={{
          wrapper: {
            top: 10,
            right: 24,
            bottom: 10,
          },
        }}
      >
        <RangePicker
          value={createdAt}
          style={{ marginBottom: 12 }}
          disabledDate={disabledDate}
          presets={rangePresets}
          allowClear={false}
          onChange={onRangeChange}
          placeholder={['开始时间', '结束时间']}
        />
        <ProList<any>
          actionRef={actionRef}
          rowKey="id"
          grid={{ gutter: 0, column: 1 }}
          onItem={(record: any) => {
            return {
              onMouseEnter: () => {
                console.log(record);
              },
              onClick: () => {
                const newKeys = [...selectedRowKeys];
                if (newKeys.includes(record.id)) {
                  newKeys.splice(newKeys.indexOf(record.id), 1);
                } else {
                  newKeys.push(record.id);
                }
                setSelectedRowKeys(newKeys);
              },
            };
          }}
          metas={{
            title: {},
            subTitle: {},
            type: {},
            avatar: {},
            content: {},
            actions: {},
          }}
          rowSelection={{
            selectedRowKeys,
            onChange: (keys: Key[], selectedRows) => {},
          }}
          rowClassName={(record) => {
            return selectedRowKeys.includes(record.id) ? 'custom-pro-checkcard-checked' : '';
          }}
          request={async (params) => {
            const { code, data }: any = await postCommonMessageList({
              page: params.current,
              page_size: params.pageSize,
              created_at: [createdAt[0].format('YYYY-MM-DD'), createdAt[1].format('YYYY-MM-DD')],
            });
            let newList: any = [];
            if (code === '200') {
              newList = data.list.map((item: any) => {
                return getListItem(item);
              });
            }
            setTotal(data.unread_count);
            return {
              data: newList,
              success: code === '200',
              total: data.total,
            };
          }}
          tableAlertRender={({ selectedRowKeys2, selectedRows, onCleanSelected }) => {
            return (
              <Space size={24}>
                <span>
                  已选 {selectedRowKeys.length} 项
                  <a
                    style={{ marginInlineStart: 8 }}
                    onClick={() => {
                      handleRead(selectedRowKeys2);
                    }}
                  >
                    批量已读
                  </a>
                </span>
              </Space>
            );
          }}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: false,
            size: 'small',
          }}
        />
      </Drawer>
    </>
  );
};
export default ModalMessageNotice;
